var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNooky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192.985,
    height: 103.618,
    viewBox: "0 0 192.985 103.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0.01 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M2.765,103.608V13.157C37.888,25.13,58.411,56.729,65.495,91.774h3.823L69.3,3.749-.01,3.479.014-.01,79.763.3l-.051,103.3H62.626l-5.663,0C51.256,54.039,19.3,29.095,6.217,22.117L6.222,103.6l-3.458.007Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("text", {
    id: "nooky",
    transform: "translate(95.975 81.834)",
    fill: "#fafafa",
    fontSize: 36,
    fontFamily: "APOLLO"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "nooky")), /*#__PURE__*/React.createElement("text", {
    id: "home_accessories",
    "data-name": "home accessories",
    transform: "translate(97.979 42.186)",
    fill: "#fafafa",
    fontSize: 7,
    fontFamily: "Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "home accessories")), /*#__PURE__*/React.createElement("text", {
    id: "_furniture",
    "data-name": "& furniture",
    transform: "translate(97.979 52.7)",
    fill: "#fafafa",
    fontSize: 7,
    fontFamily: "Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&amp; furniture")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNooky);
export default __webpack_public_path__ + "static/media/logo-nooky.8c96d7229e22af2ffe17e7c321154eb8.svg";
export { ForwardRef as ReactComponent };